module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/human-4003c903e60f8832b2cd38af7e574947.png";